import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  title: string;
  body: string;
  backTo?: { to: string; label: string };
}

const AuthPlaceholder: React.FC<Props> = ({ title, body, backTo }) => (
  <div className="app-layout min-h-screen flex items-center justify-center py-12 px-4">
    <div className="max-w-md w-full text-center">
      <div className="app-brand" style={{ fontSize: '32px', marginBottom: '16px' }}>
        babylon.markets
      </div>
      <div className="app-card" style={{ padding: '24px' }}>
        <h2 style={{ color: '#ffffff', fontSize: '20px', marginBottom: '12px' }}>
          {title}
        </h2>
        <p style={{ color: '#cccccc', fontSize: '14px', lineHeight: 1.6 }}>{body}</p>
        {backTo && (
          <p style={{ marginTop: '20px' }}>
            <Link to={backTo.to} style={{ color: '#2962ff' }}>
              {backTo.label}
            </Link>
          </p>
        )}
      </div>
    </div>
  </div>
);

export const TermsPlaceholder: React.FC = () => (
  <AuthPlaceholder
    title="Terms of Service"
    body="Our full Terms of Service will be published here. By using babylon.markets you agree to use the product for personal, non-commercial covered-call analysis only."
    backTo={{ to: '/register', label: 'Back to sign up' }}
  />
);

export const PrivacyPlaceholder: React.FC = () => (
  <AuthPlaceholder
    title="Privacy Policy"
    body="Our full Privacy Policy will be published here. We store only the email and password you sign up with, plus the positions and preferences you record. We do not sell your data."
    backTo={{ to: '/register', label: 'Back to sign up' }}
  />
);

export default AuthPlaceholder;
